import styled from 'styled-components'

export const CheckboxLabel = styled.label`
  font-size: ${props => props.theme.typography.fontSize.input};
  color: ${props => props.theme.colors.text.primary};
  cursor: pointer;
  user-select: none;
  font-family: ${props => props.theme.typography.fontFamily};

  &:has(input:disabled) {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
